(function () {
    const selectors = {
        container: ".js-login-container",
        loginFirstStepContainer: ".js-login-first-step",
        loginSecondStepContainer: ".js-otp-confirmation",
        loginForm: ".js-form-login",
        confirmEmailText: ".js-confirm-email-text",
        formLoginInput: ".js-form-login-input",
        otpForm: ".js-otp-form",
        otpInput: ".js-otp-input",
        otpFormError: ".js-otp-form-error",
        registerForm: ".js-form-register",
        registerFormPhone: ".js-register-form-phone",
        loginThirdStepContainer: ".js-login-third-step",
        backToFirstStepButton: ".js-back-to-first-step-button",
        backToPreviousPageButton: ".js-back-button",
        resendCodeButton: ".js-resend-code-button",
        otpFormSuccess: ".js-otp-form-success",
        loader: ".loader"
    };

    const classes = {
        hide: "hidden",
        loading: "loading",
    };

    let loginFirstStepContainer = null;
    let loginSecondStepContainer = null;
    let loginThirdStepContainer = null;
    let iti = null;
    const errorMap = [
        "Please, adjust the following: phone number is invalid.",
        "Please, adjust the following: phone number is invalid.",
        "Please, adjust the following: phone number is invalid.",
        "Please, adjust the following: phone number is invalid.",
        "Please, adjust the following: phone number is invalid."
    ];
    let secondStepEventsInitialized = false;
    let thirdStepEventsInitialized = false;
    let globalEmail = null;
    let isResendingOtp = false;
    // a network failure or a non-JSON 5xx lands in the catch blocks; server
    // errors (wrong or expired code) already write their own message
    const NETWORK_ERROR_MESSAGE = "Something went wrong. Please check your connection and try again.";

    function init() {
        const section = document.querySelector(selectors.container);

        if (!section) return null;

        // a successful code keeps its form loading while the browser follows
        // the multipass redirect; Back from /account can restore this page
        // from the bfcache in that state (pointer-events: none), so reset it
        window.addEventListener("pageshow", event => {
            if (!event.persisted) return;
            section.querySelectorAll(`${selectors.loginForm}, ${selectors.otpForm}, ${selectors.registerForm}`).forEach(form => {
                form.classList.remove(classes.loading);
            });
        });

        initFirstStepEvents(section);
        initCustomPhoneInput(section);
        backToFirstStep();
        backToPreviousPageButton();
    }

    function showNetworkError(otpFormError) {
        if (!otpFormError) return;
        otpFormError.textContent = NETWORK_ERROR_MESSAGE;
        otpFormError.classList.remove(classes.hide);
    }

    function initFirstStepEvents(section) {
        loginFirstStepContainer = section.querySelector(selectors.loginFirstStepContainer);

        if (!loginFirstStepContainer) return null;

        const loginForm = loginFirstStepContainer.querySelector(selectors.loginForm);

        if (!loginForm) return null;

        loginForm.addEventListener("submit", async event => {
            event.preventDefault();
            const emailInput = loginForm.querySelector(selectors.formLoginInput);
            const otpFormError = loginFirstStepContainer.querySelector(selectors.otpFormError);

            if (!emailInput || !otpFormError) return null;

            globalEmail = emailInput.value.trim();

            try {
                loginForm.classList.add(classes.loading);

                const data = await sendOtpRequest(otpFormError);

                if (data.success) {
                    initSecondStepEvents(section);
                    emailInput.value = "";
                }
            } catch (error) {
                console.error("Error:", error);
                showNetworkError(otpFormError);
            } finally {
                loginForm.classList.remove(classes.loading);
            }
        });
    }

    function initSecondStepEvents(section) {
        loginFirstStepContainer.classList.add(classes.hide);

        loginSecondStepContainer = section.querySelector(selectors.loginSecondStepContainer);

        if (!loginSecondStepContainer) return null;

        loginSecondStepContainer.classList.remove(classes.hide);

        const confirmEmailText = loginSecondStepContainer.querySelector(selectors.confirmEmailText);
        const otpFormError = loginSecondStepContainer.querySelector(selectors.otpFormError);
        const otpFormSuccess = loginSecondStepContainer.querySelector(selectors.otpFormSuccess);

        if (!confirmEmailText || !otpFormError || !otpFormSuccess) return null;

        confirmEmailText.innerText = globalEmail;

        const otpForm = loginSecondStepContainer.querySelector(selectors.otpForm);

        if (!otpForm) return null;

        if (secondStepEventsInitialized) return null;

        window.initOtpInputs?.(otpForm, selectors.otpInput);

        otpForm.addEventListener("submit", async (event) => {
            event.preventDefault();

            // pointer-events: none stops taps, not the keyboard Go key
            if (otpForm.classList.contains(classes.loading)) return;

            let leaving = false;
            const inputs = otpForm.querySelectorAll(selectors.otpInput);

            let otp = "";
            inputs.forEach((input) => {
                otp += input.value.trim();
            });

            try {
                otpForm.classList.add(classes.loading);

                const response = await verifyShopifyUserRequest(otp, otpFormError);

                if (response.success) {
                    const data = response.data?.data;
                    const accessToken = data?.session?.accessToken;
                    const refreshToken = data?.session?.refreshToken;
                    const multipassToken = data?.redirect_url.split("multipass/")[1];

                    if (accessToken && refreshToken) {
                        window.setCookie("customerBackendToken", accessToken);
                        window.setCookie("customerBackendRefreshToken", refreshToken);
                        const isSecure = window.location.protocol === 'https:';
                        const cookieSuffix = isSecure ? '; secure; samesite=strict' : '; samesite=lax';
                        document.cookie = `multipassToken=${multipassToken}; path=/${cookieSuffix}`;
                    }

                    const redirectUrl = new URL(response.data.data?.redirect_url);
                    redirectUrl.protocol = window.location.protocol;
                    redirectUrl.host = window.location.host;
                    leaving = true;
                    window.location.href = redirectUrl.toString();
                } else if (response.status === 404) {
                    initRegisterForm(section);
                }
            } catch (error) {
                console.error("Error:", error);
                showNetworkError(otpFormError);
            } finally {
                // the spinner stays up while the page navigates away
                if (!leaving) otpForm.classList.remove(classes.loading);
            }
        });

        const resendCodeButton = loginSecondStepContainer.querySelector(selectors.resendCodeButton);

        if (resendCodeButton) {
            resendCodeButton.addEventListener("click", async () => {
                const buttonLoader = resendCodeButton.querySelector(selectors.loader);

                if (isResendingOtp) return;

                isResendingOtp = true;
                resendCodeButton.classList.add(classes.loading);
                buttonLoader?.classList.remove(classes.hide);

                if (!otpFormSuccess.classList.contains(classes.hide)) {
                    otpFormSuccess.classList.add(classes.hide);
                }

                try {
                    const data = await sendOtpRequest(otpFormError, otpFormSuccess);

                    if (data.success) {
                        otpFormSuccess.classList.remove(classes.hide);
                    }
                } finally {
                    isResendingOtp = false;
                    resendCodeButton.classList.remove(classes.loading);
                    buttonLoader?.classList.add(classes.hide);
                }
            });
        }

        secondStepEventsInitialized = true;
    }

    function initCustomPhoneInput(section) {
        loginThirdStepContainer = section.querySelector(selectors.loginThirdStepContainer);

        if (!loginThirdStepContainer) return null;

        const registerFormPhone = loginThirdStepContainer.querySelector(selectors.registerFormPhone);

        if (!registerFormPhone) return null;

        // jsdelivr blocked (content blocker, corporate network): register
        // without the phone field rather than throw and take the back
        // buttons down with init()
        if (typeof window.intlTelInput !== "function") return null;

        iti = window.intlTelInput(registerFormPhone, {
            loadUtils: () => import("https://cdn.jsdelivr.net/npm/intl-tel-input@25.10.4/build/js/utils.js"),
            initialCountry: "us",
            preferredCountries: ["us", "ca", "gb", "ua"],
            separateDialCode: true,
            countrySearch: false,
        });

        function renderSelectedIso() {
            const data = iti.getSelectedCountryData();
            const selected = registerFormPhone.parentElement.querySelector(".iti__selected-country-primary");
            if (!selected) return;

            selected.innerHTML = `<span class="iti__selected-country-primary-code">${data.iso2.toUpperCase()}</span>`;
        }

        renderSelectedIso();

        registerFormPhone.addEventListener("countrychange", () => {
            renderSelectedIso();
        });
    }

    function initRegisterForm(section) {
        loginSecondStepContainer.classList.add(classes.hide);
        loginThirdStepContainer = section.querySelector(selectors.loginThirdStepContainer);
        const otpFormError = loginThirdStepContainer.querySelector(selectors.otpFormError);

        const registerForm = loginThirdStepContainer.querySelector(selectors.registerForm);

        if (!loginThirdStepContainer || !registerForm) return null;

        loginThirdStepContainer.classList.remove(classes.hide);

        if (thirdStepEventsInitialized) return null;

        registerForm.addEventListener("submit", async event => {
            event.preventDefault();

            if (registerForm.classList.contains(classes.loading)) return;

            let leaving = false;
            // without intl-tel-input there is no validated number to send
            const phoneNumber = iti ? iti.getNumber() : "";
            const isValidNumberPrecise = iti ? iti.isValidNumberPrecise() : true;

            if (!isValidNumberPrecise && phoneNumber.length > 0) {
                const errorCode = iti.getValidationError();

                otpFormError.innerHTML = errorMap[errorCode] || "Invalid number";
                otpFormError.classList.remove(classes.hide);
                return;
            } else {
                if (!otpFormError.classList.contains(classes.hide)) {
                    otpFormError.classList.add(classes.hide);
                    otpFormError.innerHTML = "";
                }
            }

            const countryData = iti ? iti.getSelectedCountryData().dialCodePlus : "";
            const formData = new FormData(registerForm);
            const data = {};

            formData.forEach((value, key) => {
                data[key] = value;
            });

            const userData = phoneNumber.length > 0 ? {
                firstName: data["customer[first_name]"],
                lastName: data["customer[last_name]"],
                phone: phoneNumber.replace(/\D/g, ""),
                countryCode: countryData
            } : {
                firstName: data["customer[first_name]"],
                lastName: data["customer[last_name]"]
            };

            try {
                registerForm.classList.add(classes.loading);

                const response = await registerShopifyUser(userData, otpFormError);

                if (response.success) {
                    const data = response.data?.data;
                    const accessToken = data?.session?.accessToken;
                    const refreshToken = data?.session?.refreshToken;
                    const multipassToken = data?.redirect_url.split("multipass/")[1];

                    if (accessToken && refreshToken) {
                        const isSecure = window.location.protocol === 'https:';
                        const cookieSuffix = isSecure ? '; secure; samesite=strict' : '; samesite=lax';
                        document.cookie = `customerBackendToken=${accessToken}; path=/${cookieSuffix}`;
                        document.cookie = `customerBackendRefreshToken=${refreshToken}; path=/${cookieSuffix}`;
                        document.cookie = `multipassToken=${multipassToken}; path=/${cookieSuffix}`;
                    }

                    const redirectUrl = new URL(response.data.data?.redirect_url);
                    redirectUrl.protocol = window.location.protocol;
                    redirectUrl.host = window.location.host;
                    leaving = true;
                    window.location.href = redirectUrl.toString();
                }
            } catch (error) {
                console.error("Error:", error);
                showNetworkError(otpFormError);
            } finally {
                if (!leaving) registerForm.classList.remove(classes.loading);
            }
        });

        thirdStepEventsInitialized = true;
    }

    function backToFirstStep() {
        document.addEventListener("click", event => {
            const target = event.target;

            if (target.closest(selectors.backToFirstStepButton)) {
                if (loginThirdStepContainer && !loginThirdStepContainer.classList.contains(classes.hide) && loginFirstStepContainer) {
                    clearSecondStep();
                    clearThirdStep();
                } else if (loginSecondStepContainer && !loginSecondStepContainer.classList.contains(classes.hide) && loginFirstStepContainer) {
                    clearSecondStep();
                }
            }
        });
    }

    function clearSecondStep() {
        const loginSecondStepContainer = document.querySelector(selectors.loginSecondStepContainer);

        loginSecondStepContainer.classList.add(classes.hide);
        loginFirstStepContainer.classList.contains(classes.hide) && loginFirstStepContainer.classList.remove(classes.hide);

        const otpForm = loginSecondStepContainer.querySelector(selectors.otpForm);
        if (otpForm) otpForm.reset();

        const otpFormError = loginSecondStepContainer.querySelector(selectors.otpFormError);
        if (otpFormError) otpFormError.classList.add(classes.hide);

        const otpFormSuccess = loginSecondStepContainer.querySelector(selectors.otpFormSuccess);
        if (otpFormSuccess) otpFormSuccess.classList.add(classes.hide);
    }

    function clearThirdStep() {
        const loginThirdStepContainer = document.querySelector(selectors.loginThirdStepContainer);

        loginThirdStepContainer.classList.add(classes.hide);
        loginSecondStepContainer.classList.add(classes.hide);
        loginFirstStepContainer.classList.contains(classes.hide) && loginFirstStepContainer.classList.remove(classes.hide);


        const otpFormError = loginThirdStepContainer.querySelector(selectors.otpFormError);
        if (otpFormError) otpFormError.classList.add(classes.hide);

        const registerForm = loginThirdStepContainer.querySelector(selectors.registerForm);
        if (registerForm) registerForm.reset();
    }

    function backToPreviousPageButton() {
        const backButton = document.querySelector(".js-back-button");

        if (!backButton) return;

        backButton.addEventListener("click", (e) => {
            e.preventDefault();

            const referrer = document.referrer;

            if (referrer && referrer.indexOf(window.location.origin) === 0 && referrer !== window.location.href) {
                window.location.href = referrer;
            } else {
                window.location.href = "/";
            }
        });
    }

    async function sendOtpRequest(otpFormError, otpFormSuccess) {
        if (!otpFormError.classList.contains(classes.hide)) {
            otpFormError.classList.add(classes.hide);
            otpFormError.innerHTML = "";
        }

        const response = await fetch(`${window.GD_API_BASE}/user-auth/send-otp?source=shopify`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email: globalEmail.toString() })
        });

        const data = await response.json();

        if (!response.ok || data.success === false) {
            otpFormError.innerHTML = "";

            if (Array.isArray(data.errors) && data.errors.length > 0) {
                otpFormError.textContent = data.errors[0].message;
            } else if (data.message) {
                otpFormError.textContent = data.message;
            }

            otpFormError.classList.remove(classes.hide);
        } else {
            if (otpFormSuccess) {
                otpFormSuccess.classList.remove(classes.hide);
            }
        }

        return {
            "success": response.ok,
            "status": response.status
        };
    }

    async function verifyShopifyUserRequest(otpCode, otpFormError) {
        if (!otpFormError.classList.contains(classes.hide)) {
            otpFormError.classList.add(classes.hide);
            otpFormError.innerHTML = "";
        }

        const response = await fetch(`${window.GD_API_BASE}/shopify-native/verify-shopify-user`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                "email": globalEmail.toString(),
                "otp": otpCode,
                "return_to": window.location.origin + "/account"
            })
        });

        const data = await response.json();

        if (!response.ok || data.success === false) {
            otpFormError.innerHTML = "";

            if (Array.isArray(data.errors) && data.errors.length > 0) {
                data.errors.forEach(err => {
                    const p = document.createElement("p");
                    p.textContent = err.message;
                    otpFormError.appendChild(p);
                });
            } else if (data.message) {
                otpFormError.textContent = data.message;
            }

            otpFormError.classList.remove(classes.hide);
        }

        return {
            "success": response.ok,
            "status": response.status,
            "data": data
        }
    }

    async function registerShopifyUser(userData, otpFormError) {
        if (!otpFormError.classList.contains(classes.hide)) {
            otpFormError.classList.add(classes.hide);
            otpFormError.innerHTML = "";
        }

        const responseObj = userData.phone && userData.countryCode ? {
            "email": globalEmail.toString(),
            "first_name": userData.firstName,
            "last_name": userData.lastName,
            "phone_number": userData.phone,
            "country_code": userData.countryCode,
            "return_to": window.location.origin + "/account"
        } : {
            "email": globalEmail.toString(),
            "first_name": userData.firstName,
            "last_name": userData.lastName,
            "return_to": window.location.origin + "/account"
        };

        const response = await fetch(`${window.GD_API_BASE}/shopify-sync/customer/signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(responseObj)
        });

        const data = await response.json();

        if (!response.ok || data.success === false) {
            otpFormError.innerHTML = "";

            if (Array.isArray(data.errors) && data.errors.length > 0) {
                data.errors.forEach(err => {
                    const p = document.createElement("p");
                    p.textContent = err.message;
                    otpFormError.appendChild(p);
                });
            } else if (data.message) {
                otpFormError.textContent = data.message;
            }

            otpFormError.classList.remove(classes.hide);
        }

        return {
            "success": response.ok,
            "status": response.status,
            "data": data
        }
    }

    init();
})();
